import { useEffect } from "react";
import { Box, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import { Schema } from "../../../api/types";
import usePostSchema from "../../../api/usePostSchema";
import { typedSxMap } from "../../../utils/typedSxMap";

type CreateSchemaModalProps = {
  isOpen: boolean;
  workspaceId: string;
  schema?: Schema | null;
  title?: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  onClose: (open: boolean) => void;
};

const styles = typedSxMap({
  modalWrapper: {
    borderRadius: "var(--border-radius-5)",
    padding: "var(--m)",
    backgroundColor: "var(--color-background-modal)",
    display: "flex",
    flexDirection: "row",
  },
  modalContent: {
    borderRadius: "var(--border-radius-5)",
    backgroundColor: "var(--color-background-modal)",
    gap: "var(--m)",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },

  container: {
    padding: 0,
    "& form": {
      display: "flex",
      gap: "12px",
      flexDirection: "column",
      alignItems: "flex-end",
      ".nameInput": {
        flexGrow: 1,
        width: "100%",
      },
    },
  },
  overlay: {
    opacity: 0.8,
  },
  header: {
    display: "flex",
    alignItems: "center",
    margin: 0,
    padding: 0,
  },
  headerWithIcon: {
    margin: "var(--m-xs) 0 var(--m-s)",
  },
  closeButton: {
    margin: "0 14px",
    height: "4",
    width: "4",
    right: "0",
    top: "2",
  },
  icon: {
    width: "var(--m-xxl)",
    height: "var(--m-xxl)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "var(--color-background-error-soft)",
    borderRadius: "var(--border-radius-r)",
    flex: "0 0 var(--m-xxl)",
    border: "5px solid var(--color-background-menu-hover)",
    "& svg": {
      display: "block",
    },
  },
});

export default function ActionModal({ isOpen, workspaceId, schema, children, title, icon, onClose }: CreateSchemaModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onClose(false);
      }}
      isCentered={true}>
      <ModalOverlay sx={styles.overlay} />
      <ModalContent sx={styles.modalWrapper}>
        <ModalCloseButton sx={styles.closeButton} />
        <Box>{icon && <Box sx={styles.icon}>{icon}</Box>}</Box>
        <Box sx={styles.modalContent}>
          <ModalHeader sx={icon ? { ...styles.header, ...styles.headerWithIcon } : styles.header}>
            <h2>{title} Schema</h2>
          </ModalHeader>
          <ModalBody sx={styles.container}>{children}</ModalBody>
        </Box>
      </ModalContent>
    </Modal>
  );
}
